export default __webpack_public_path__ + "static/media/sh2_4.e33208a4.jpg";